import ClubItemBase from "./club_item_base";
import UserDataManager from "../../../manager/user_manager";
import ModelData from "../../public/model_data";
import { club_utils } from "../club_utils";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ClubMemberBase extends ClubItemBase {

    @property(cc.Sprite)
    icon: cc.Sprite = null;

    @property(cc.Label)
    avatarName: cc.Label = null;

    @property(cc.Label)
    currency : cc.Label = null;

    
    private _isAdmin : boolean;
    /**
     * 是否为管理员
     */
    get isAdmin() : boolean {
        return this._isAdmin;
    }

    private _isOwner : boolean;
    get isOwner() : boolean{
        return this._isOwner;
    }

    private _data : any;
    get data() : any {
        return this._data;
    }
    
    get userId() : number {
        return this.data.gameUserId;
    }

    /**
     * 是否是自己
     */
    get isSelf() : boolean{
        return club_utils.avatarId == this.data.gameUserId;
    }

 
    updateInfo(data : any){

        this._data = data;

        this._isAdmin = data.clubUserType == "owner" || data.clubUserType == "admin";
        
        this._isOwner = data.clubUserType == "owner";

        if (this.avatarName) {
            this.avatarName.string = data.nickname;
        }

        UserDataManager.getAvatarSprite(data.headImg,(spriteFrame)=>{
            this.icon.spriteFrame = spriteFrame;
        });

        if (data.goldBalance && this.currency) {
            
            this.currency.string = data.goldBalance;
        }
        
    }

    public updateCurrency(value : number){

        this.currency.string = value.toString();
    }
 
}
